import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const CountryDisplay = () => {
  const { user } = useAuth();
  const cout = user?.country;

  const getCountryName = async (code) => {
    try {
      const response = await fetch(
        `https://restcountries.com/v3.1/alpha/${code}`
      );
      if (!response.ok) throw new Error("Country not found");

      const data = await response.json();
      return data[0]?.name?.common || code.toUpperCase();
    } catch {
      return "Country not found";
    }
  };

  // <-- change this to any 2-letter country code
  const [countryName, setCountryName] = useState("");

  useEffect(() => {
    const fetchName = async () => {
      const name = await getCountryName(cout);
      setCountryName(name);
    };
    fetchName();
  }, [cout]);

  return (
    <div style={{ padding: "1rem", fontFamily: "Arial" }}>
      <p>{countryName}</p>
    </div>
  );
};

export default CountryDisplay;
